import { HttpClient } from '@angular/common/http'
import { computed, inject, Injectable, signal } from '@angular/core'
import { Observable, tap } from 'rxjs'
import { Me } from '../interfaces/me/me.interface'
import { NotificationPreference } from '../interfaces/me/notification-preference.interface'
import { Permissions } from '../permissions'

@Injectable({
    providedIn: 'root',
})
export class MeService {
    #httpClient = inject(HttpClient)

    #me = signal<Me | null>(null)

    readonly me = this.#me.asReadonly()
    readonly permissions = computed(() => this.#me()?.permissions || [])

    getMe(): Observable<Me> {
        return this.#httpClient.get<Me>(`/api/me`).pipe(tap((me) => this.#me.set(me)))
    }

    updateNotificationPreferences(preferences: NotificationPreference[]): Observable<void> {
        return this.#httpClient.put<void>(`/api/me/preferences/notifications`, preferences)
    }

    updatePrivacyPreferences(enableAnalytics: boolean, enableSessionReplay: boolean): Observable<void> {
        return this.#httpClient.put<void>(`/api/me/preferences/privacy`, { enableAnalytics, enableSessionReplay })
    }

    hasPermission(permission: Permissions): boolean {
        return this.permissions().includes(permission)
    }

    hasAnyPermission(permissions: readonly Permissions[]): boolean {
        return permissions.some((permission) => this.hasPermission(permission))
    }

    hasAllPermissions(permissions: readonly Permissions[]): boolean {
        return permissions.every((permission) => this.hasPermission(permission))
    }

    clear(): void {
        this.#me.set(null)
    }
}
